import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import LanguageSelector from "./LanguageSelector";

/**
 * PreLaunchLegalLayout — coquille minimale pour les pages légales / consentement
 * pendant le mode pré-lancement (visiteur non authentifié).
 *
 * Objectif (Phase 14 STEP 1) : afficher le contenu légal requis SANS exposer la
 * navigation publique normale (menus Croisières/Hôtels/Restaurants, recherche,
 * découverte d'articles, Avantages…). Uniquement : logo ITERCATUS, le contenu,
 * et un retour discret vers Coming Soon.
 */
export default function PreLaunchLegalLayout({ children }) {
  return (
    <div className="min-h-screen bg-secondary flex flex-col" data-testid="prelaunch-legal-layout">
      <header className="border-b border-border/40 bg-white/80 backdrop-blur">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/coming-soon" className="flex items-center gap-2" data-testid="prelaunch-legal-logo">
            <img
              src="/images/logo-itercatus.png"
              alt="ITERCATUS"
              className="h-10 w-auto object-contain"
              onError={(e) => {
                e.target.style.display = "none";
                e.target.parentElement.innerHTML =
                  '<span class="font-heading text-lg font-bold text-primary">ITERCATUS</span>';
              }}
            />
          </Link>
          <div className="flex items-center gap-3">
            <LanguageSelector variant="dark" />
            <Link
              to="/coming-soon"
              className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-primary transition-colors"
              data-testid="prelaunch-legal-back"
            >
              <ArrowLeft className="h-4 w-4" />
              Retour
            </Link>
          </div>
        </div>
      </header>

      <main className="flex-1">{children}</main>

      <footer className="border-t border-border/40 py-6">
        <div className="max-w-3xl mx-auto px-6 text-center text-xs text-muted-foreground">
          © {new Date().getFullYear()} ITERCATUS — Journal de voyage numérique.
        </div>
      </footer>
    </div>
  );
}
